<template>
  <div class="rc-data-source-runtime" :class="{getClassByCopy,'to-top':component.properties.sortType==='toTop'}" @mouseenter.stop="controlMouseOver(component, index)" @click="controlClick(component, index)">
    <el-form-item class="rc-input-run" ref="rcDataSource" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :prop="getProp" :rules="rules" :class="{'hide-error':getValue!=='请选择'&&getValue,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}"
                  :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-tooltip popper-class="file-tooltip-datasource" transition="''" :visible-arrow="false" effect="light" placement="bottom-start" :disabled="currentSelectFile.length === 0">
        <div slot="content">
          <div v-for="(pic,index) in currentSelectFile"
               class="file-cotent"
               :key="index">
            <span class="item" :title="pic.name">{{pic.name}}</span>
            <span class="download" @click.stop="downFile(pic)"><i class="el-icon-download"></i>下载</span>
            <span class="preivew" @click.stop="preivewFile(pic)"><i class="el-icon-view"></i>预览</span>
          </div>
        </div>
        <label class="selected" :class="{'readonly':disabled || component.properties.readonly,'view':disabled}" :title="getValue | format">
          <u @click="initReport">{{getValue | format}}</u></label>
      </el-tooltip>
    </el-form-item>
   <el-dialog :ref="component.id" class="rc-data-source-dialog" title="请选择" width="680px" :visible.sync="dialogTableVisible" center append-to-body :close-on-click-modal="false">
    <report-filter
      :ref="component.id + 'filter'"
      v-if="filters.length&&dialogTableVisible"
      :componentWidth="componentWidth"
      :reportFilters="filters"
      :isRcDataSource="true"
      :filterDefaultValue="component.properties.dataSourceData.filter"
      :reportId="component.properties.dataSourceData.dataSource"
      @reset="reset"
      @search="searchFilter"/>
    <el-table ref="multipleTable"
              class="el-dialog__headerdata-source-table"
              :data="data"
              v-loading="loading"
              highlight-current-row
              @current-change="handleSelectionChange"
              @row-click="handleRowClick"
              height="400"
              border>
      <el-table-column
         v-if="!isTable"
          label=""
          width="35">
          <template slot-scope="scope">
            <el-checkbox :value="scope.row===currentRow"></el-checkbox>
          </template>
        </el-table-column>
         <el-table-column
         v-else
          width="35">
          <template slot-scope="scope">
            <el-checkbox :value="getSelect(scope.row)" @change="updateCheck($event, scope.row)"></el-checkbox>
          </template>
        </el-table-column>
      <template v-for="(column, index) in columns">
        <el-table-column
          v-if="!column.hidden && column.columnType && column.columnType.toLowerCase() !== 'file'"
          :prop="column.id"
          align="center"
          :key="index"
          show-overflow-tooltip
          min-width="115px">
          <template slot="header" slot-scope="scope">
            <span :title="column.name.length > 5 ? column.name : ''" class="column-header">{{ column.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!column.hidden && column.columnType && column.columnType.toLowerCase() === 'file'"
          :prop="column.id"
          align="center"
          :key="index"
          show-overflow-tooltip
          min-width="115px">
          <template slot="header" slot-scope="scope">
            <span :title="column.name.length > 5 ? column.name : ''" class="column-header">{{ column.name }}</span>
          </template>
          <template slot-scope="scope" >
            <span v-if="formatPicData(scope.row[column.id]).length === 0">-</span>
            <div class="file-list" v-else>
              <el-tooltip popper-class="file-tooltip" transition="''" :visible-arrow="false" class="file-name" placement="bottom" v-if="formatPicData(scope.row[column.id]).length === 1">
                <div class="title" slot="content">
                  <div class="down" @click.stop="downFile(formatPicData(scope.row[column.id])[0])"><i class="el-icon-download"></i>下载</div>
                  <div class="preivew" @click.stop="preivewFile(formatPicData(scope.row[column.id])[0])"><i class="el-icon-view"></i>预览</div>
                </div>
                <div class="one-file">{{formatPicData(scope.row[column.id])[0].name}}</div>
              </el-tooltip>
              <el-dropdown placement="bottom" v-else>
                <span class="el-dropdown-link">
                  {{ `附件（${getFileLength(scope.row[column.id])}）` }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu class="rc-file-dropdown table-dropdown rc-data-source-dropdown" slot="dropdown">
                  <el-dropdown-item
                    v-for="(pic,index) in formatPicData(scope.row[column.id])"
                    :command="pic.link"
                    :key="index">
                    <a class="item" :title="pic.name">{{pic.name}}</a>
                    <div class="preivew-or-down">
                      <div class="down" @click.stop="downFile(pic)"><i class="el-icon-download"></i>下载</div>
                      <div class="preivew" @click.stop="preivewFile(pic)"><i class="el-icon-view"></i>预览</div>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagination.pageSizes"
      :page-size="pagination.pageSize"
      layout="total, prev, pager, next, sizes"
      :total="pagination.count">
    </el-pagination>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save">{{saveBtn}}</el-button>
      <el-button @click="dialogTableVisible = false">取 消</el-button>
    </div>
   </el-dialog>
  </div>
</template>

<script>
import { componentMixin, inputMixin, calculationMixin } from './mixins'
import ReportFilter from '../../../report/runtime/report-filter.vue'
export default {
  name: 'rc-data-source',
  mixins: [ componentMixin, inputMixin, calculationMixin ],
  props: [ 'component', 'value', 'index', 'disabled', 'custParams', 'labelParameter', 'isTable', 'tableCtrlKey' ],
  components: {
    ReportFilter
  },
  data () {
    return {
      dialogTableVisible: false,
      columns: [],
      filters: [],
      param: {},
      currentRow: {},
      data: [],
      loading: false,
      selectRow: -1,
      pagination: { currentPage: 1, pageSize: 10, pageSizes: [10, 20, 30, 50, 100], count: 0 },
      currenSelectId: '',
      timer: null,
      num: null,
      componentWidth: 650,
      // 表格内的数据源可以多选
      tableCurrentRows: [],
      currentSelectFile: [],
      isemit: false,
      maxTotal: null
    }
  },
  filters: {
    format: function (value) {
      if (!value) return ''
      if (typeof value === 'string' && value.includes('$.$')) {
        let array = []
        value.split('$.$').forEach(m => {
          if (m) {
            array.push({'name': m.split(',/')[0], 'link': '/' + m.split(',/')[1]})
          }
        })
        return array.map(e => e.name).join()
      } else {
        return value
      }
    }
  },
  watch: {
    'pagination.currentPage' (val) {
      this.intParam()
    },
    'pagination.pageSize' (val) {
      this.intParam()
    },
    'dialogTableVisible' (val) {
      if (!val) {
        this.currentRow = {}
        this.tableCurrentRows = []
      }
    }
  },
  mounted () {
    // todo: 使用值是否含$.$符号来判断是否文件, 不够准确
    if (this.value && this.currentSelectFile.length === 0 && typeof this.value === 'string' && this.value.includes('$.$')) {
      this.currentSelectFile = this.formatPicData(this.value)
    }
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    handleColumns (columns) {
      // 将字段重新进行排序
      this.columns = this.$_.sortBy(columns, m => m.sort)
      this.columns.forEach(m => {
        if (m.format != null) {
          m.format.colorFormats = JSON.parse(m.format.colorFormats)
          m.format.displayFormats = JSON.parse(m.format.displayFormats)
          m.format.dataFormat = JSON.parse(m.format.dataFormat)
        } else {
          m.format = {
            colorFormats: [],
            displayFormats: [],
            dataFormat: {}
          }
        }
      })
    },
    handleSelectionChange (row) {
      if (!this.isTable) {
        this.currentRow = row || {}
      }
    },
    handleRowClick (row, column, event) {
      if (this.isTable) {
        let index = this.tableCurrentRows.findIndex(r => r.Id === row.Id)
        if (index === -1) {
          this.tableCurrentRows.push(row)
        } else {
          this.tableCurrentRows.splice(index, 1)
        }
      }
    },
    updateCheck (state, row) {
      if (!state) {
        let index = this.tableCurrentRows.findIndex(r => r.Id === row.Id)
        index !== -1 && this.tableCurrentRows.splice(index, 1)
      } else {
        this.tableCurrentRows.push(row)
      }
    },
    async initReport () {
      if (!(this.disabled || this.component.properties.readonly)) {
        try {
          this.eventBus.$emit('component.data-source.initReport', {component: this.component})
        } catch (e) {
          console.warn(e)
          return
        }
        // 1.如果数据源有数据才执行
        if (this.component.properties.dataSourceData.dataSource) {
          await this.loadReport()
          await this.intParam(false)
          await this.reset().then(() => {
            this.dialogTableVisible = true
            this.$nextTick(() => {
              let ref = this.$refs[this.component.id + 'filter']
              if (ref) {
                this.$refs[this.component.id + 'filter'] && this.$refs[this.component.id + 'filter'].init()
                this.componentWidth = ref.$el.offsetWidth + 20
              }
            })
          })
        }
      }
    },
    loadReport () {
      let reportId = this.component.properties.dataSourceData.dataSource
      // 区分外链与平台请求接口
      let reportDefineAPI = this.$route.name === 'formRuntimeOutsideChain' ? `/report-api/report/definition/forPublic/${reportId}?type=` : `/report-api/report/definition/${reportId}?type=run`
      return this.$axios.get(reportDefineAPI)
        .then(res => {
          res.data.filters && res.data.filters.forEach(n => {
            n.dataSource = JSON.parse(n.dataSource)
            n.template = JSON.parse(n.template)
            // 筛选项是否隐藏状态值赋值
            n.filterHidden = this.component.properties.dataSourceData.filterHide[n.id]
          })
          this.maxTotal = Number(res.data.maxTotal)
          this.handleColumns(res.data.columns)
          this.filters = res.data.filters.filter(m => m.filterType !== 'senior')
        })
    },
    reset () {
      this.param.index = 1
      let condition = {}
      this.filters.forEach(m => {
        condition[m.id] = m.defaultValue
      })
      return this.searchFilter({condition})
    },
    intParam (isLoad = true) {
      this.param.index = this.pagination.currentPage
      this.param.size = this.pagination.pageSize
      return isLoad ? this.loadData() : Promise.resolve()
    },
    searchFilter ({condition, isemit}) {
      this.param.filters = this.$_.cloneDeep(condition)
      if (this.pagination.currentPage !== 1) {
        this.pagination.currentPage = 1
        return
      }
      // 判断是点击查询按钮穿过来的
      this.isemit = isemit || false
      return this.loadData()
    },
    getFileLength (files) {
      let array = files.split('$.$') || []
      return array && array.length ? array.filter(c => c && c).length : 0
    },
    formatPicData (data, type) {
      let array = []
      if (data) {
        data.split('$.$').forEach(m => {
          if (m) {
            array.push({'name': m.split(',/')[0], 'link': '/' + m.split(',/')[1]})
          }
        })
      }
      if (type === 'update') {
        this.currentSelectFile = array
        return array.map(e => e.name).join()
      } else {
        return array
      }
    },
    downFile (item) {
      if (item.link.includes('http')) {
        const x = new XMLHttpRequest()
        x.open('GET', item.link, true)
        x.responseType = 'blob'
        x.onload = function (e) {
          const url = window.URL.createObjectURL(x.response)
          const a = document.createElement('a')
          a.href = url
          a.download = item.name
          a.click()
        }
        x.onerror = function () {
          window.open(item.link)
        }
        x.send()
      } else {
        window.open(`${location.origin}/shared-api/files/download?data=${encodeURIComponent('$.$')}${encodeURIComponent(item.name)},${item.link}`)
      }
    },
    preivewFile (item) {
      // 非 doc、docx、xls、xlsx 走 view 接口
      if (item.link) {
        let src = item.link
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        if (['doc', 'docx', 'xls', 'xlsx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: item.name}}).href
          window.open(href, '_blank')
        } else if (['png', 'jpg', 'jpeg', 'gif'].includes(type)) {
          let href = this.$router.resolve({name: 'imagePreview', query: {src: src.includes('http') ? src : sessionStorage.getItem('ossDownloadUrl') + src, name: item.name}}).href
          window.open(href, '_blank')
        } else if (['pdf', 'txt'].includes(type)) {
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          src.includes('http') ? window.open(src) : window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
        } else {
          this.$message.info('暂不支持该类型文件预览！')
        }
      }
    },
    async loadData () {
      try {
        await this.eventBus.$emit('component.data-source.loadData', {component: this.component})
      } catch (e) {
        console.warn(e)
        return
      }
      this.loading = true
      return new Promise(async resolve => {
        await this.loadReportwithFilter().then(res => {
          res[0] && Object.keys(res[0]).forEach(key => {
            this.filters.filter(filter => filter.id === key)[0].defaultValue = res[0][key]
          })
          this.getData(res instanceof Array ? res.pop() : res).then(res => this.eventBus.$emit('component.data-source.loadedData', {component: this.component, data: this.data}))
          this.$nextTick(() => {
            resolve()
          })
        })
      })
      // this.loadReportwithFilter().then(res => this.getData(res instanceof Array ? res.pop() : res))
    },
    loadReportwithFilter () {
      const filters = this.$_.cloneDeep(this.component.properties.dataSourceData.filter)
      if (filters && Object.keys(filters).length) {
        return Promise.all(Object.keys(filters).map(m => this.getPromise(m, filters)))
      } else {
        return Promise.resolve(filters)
      }
    },
    getPromise (m, filters) {
      return new Promise(resolve => {
        if (!filters[m]) return resolve(filters)
        const expression = {
          'expression': this.$_.clone(filters[m]),
          'path': this.getCurrentPath(),
          'callback': (data) => {
            filters[m] = data
            resolve(filters)
          }
        }
        this.getCalculationValue(expression)
      })
    },
    async getData  (filters) {
      let reportId = this.component.properties.dataSourceData.dataSource
      let params = this.$_.cloneDeep(this.param)

      // 以下是64期之前的数据源筛选项逻辑
      // let cloneFilters = this.$_.cloneDeep(filters)
      // 如果是点查询按钮需要把筛选项中的值带过来
      // if (this.isemit) {
      //   // 57期再次筛选  如果数据源的筛选项有默认值，然后在进行第二次筛选，处理格式变成如下
      //   // filter[uuid]: 张晓燕&高创
      //   // filter[repeat]:  uuid
      //   params.filters['repeat'] = ''
      //   // for (let key in cloneFilters) {
      //   // if (params.filters[key] && cloneFilters[key]) {
      //   // params.filters[key] = `${cloneFilters[key]}&&${params.filters[key]}`
      //   // params.filters['repeat'] += `${key} `
      //   // } else if (!params.filters[key] && cloneFilters[key]) {
      //   //     params.filters[key] = cloneFilters[key]
      //   //   }
      //   // }
      //   params.filters['repeat'] = params.filters['repeat'] ? params.filters['repeat'].trim().split(' ').join(',') : ''
      // } else{
      // params.filters = filters
      //    }
      // 默认筛选项有值的时候
      if (!this.isemit) {
        params.filters = filters
      }
      // 区分外链与平台请求接口
      let reportCountAPI = this.$route.name === 'formRuntimeOutsideChain' ? `/report-api/report/data/forPublic/${reportId}/count` : `/report-api/report/data/${reportId}/count`
      let reportDataAPI = this.$route.name === 'formRuntimeOutsideChain' ? `/report-api/report/data/forPublic/${reportId}/` : `/report-api/report/data/${reportId}`
      this.$axios.get(reportCountAPI, { params })
        .then(res => {
          this.pagination.count = this.maxTotal && res.data > this.maxTotal ? this.maxTotal : res.data
        })
      await this.$axios.get(reportDataAPI, { params })
        .then(res => {
          let flag = /(^[1-9]\d*$)/.test(this.maxTotal / params.size) ? Math.ceil(this.maxTotal / params.size) + 1 === params.index : Math.ceil(this.maxTotal / params.size) === params.index
          if (this.maxTotal && flag) {
            res.data = res.data.slice(0, this.maxTotal % params.size)
          }
          this.data = res.data
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    async save () {
      try {
        // 表格内数据源修改为可多选
        let currentRow = this.isTable ? this.tableCurrentRows : this.currentRow
        await this.eventBus.$emit('component.data-source.beforeSave', { currentRow, component: this.component })
      } catch (e) {
        console.warn(e)
        return
      }
      let currentRow = this.isTable ? (this.tableCurrentRows[0] || {}) : this.currentRow
      if (!currentRow || Object.keys(currentRow).length === 0) {
        if (this.value) {
          this.update('')
          this.currentSelectFile = []
          this.component.properties.dataSourceData.dataBinding && this.component.properties.dataSourceData.dataBinding.forEach(m => {
            if (m.showColumnId && m.componentId) {
              // 这个地方使用的应该归档ID, 但是命名的时候使用了 componentId
              this.update({'value': '', 'archiveColumnId': m.componentId})
            }
          })
          this.dialogTableVisible = false
        } else {
          this.$message({
            message: '你没有选择任何数据, 请选择后操作.',
            center: true,
            duration: 1000,
            customClass: 'without-execute-dialog'
          })
        }
      } else {
        // 如果选了多行数据，需要将表格内的数据向下延展
        if (this.isTable && this.tableCurrentRows.length > 1) {
          let data = {
            values: this.tableCurrentRows.slice(1),
            index: this.index,
            columnId: this.component.archive.columnId,
            component: this.component
          }
          this.$emit('saveDataSource', data)
        }
        let showColunm = this.columns.find(column => column.id === this.component.properties.dataSourceData.showColumnId)
        let columnType = showColunm && showColunm.columnType
        // 选择文件的时候操作
        if (columnType && columnType.toLowerCase() === 'file') {
          this.formatPicData(this.currentRow[this.component.properties.dataSourceData.showColumnId], 'update')
        }
        this.update(currentRow[this.component.properties.dataSourceData.showColumnId])
        this.component.properties.dataSourceData.dataBinding && this.component.properties.dataSourceData.dataBinding.forEach(m => {
          if (m.showColumnId && m.componentId) {
            // 这个地方使用的应该归档ID, 但是命名的时候使用了 componentId
            this.update({'value': currentRow[m.showColumnId], 'archiveColumnId': m.componentId})
          }
        })
        this.dialogTableVisible = false
      }
      // 触发值改变事件
      this.$nextTick(() => {
        this.executeFunctions('change')
        this.$refs.rcDataSource.validate('change')
      })
    }
  },
  computed: {
    getSelect () {
      return row => !!this.tableCurrentRows.find(n => n.Id === row.Id)
    },
    saveBtn () {
      let currentRow = this.isTable ? (this.tableCurrentRows[0] || {}) : this.currentRow
      if (this.value && JSON.stringify(currentRow) === '{}') {
        return '确定清除'
      } else {
        return '确定选择'
      }
    },
    // custParams：该参数是 表格控件独用的。当该值有值时，应当优先使用
    getValue () {
      return this.custParams && this.custParams.value !== undefined ? this.custParams.value : this.value ? this.value : '请选择'
    }

  }
}
</script>
<style lang="scss">
.rc-data-source-runtime {
  height: 28px;
  line-height: 28px;
  .el-form-item__content {
    .el-tooltip.selected {
      margin-right: 0;
      color: var(--primary, #54ABF1);
    }
  }
  .selected {
    display: inline-block;
    width: 100%;
    color: var(--primary, #54ABF1);
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .view{
    color:#2A2929;
  }
  .hide-error{
    .selected {
      u {
        color: var(--primary, #54ABF1);
      }
    }

    .view {
      u {
        color: #2A2929;
      }
    }
    .el-form-item__error{
      opacity: 0;
    }
  }
  .is-error{
    .selected u{
      color: #F56C6C;
    }
    .el-form-item__error{
      opacity: 0;
    }
  }
  .readonly {
    color: #2A2929;
    u {
       text-decoration: none;
    }
  }
}
.rc-data-source-runtime.to-top {
  height: 56px;
  line-height: 28px;
  .el-form-item__content {
    .el-tooltip.selected {
      margin-right: 0;
      color: #54ABF1;
    }
  }
  .selected {
    display: inline-block;
    width: 100%;
    color: #54ABF1;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .view{
    color:#2A2929;
  }
  .hide-error{
    .selected {
      u {
        color: #54ABF1;
      }
    }
    .view {
      u {
        color: #2A2929;
      }
    }
    .el-form-item__error{
      opacity: 0;
    }
  }
  .is-error{
    .selected u{
      color: #F56C6C;
    }
    .el-form-item__error{
      opacity: 0;
    }
  }
  .readonly {
    color: #2A2929;
    u {
      text-decoration: none;
    }
  }
}
.rc-data-source-dialog {
  .el-dialog {
    border-radius: 4px;
    .pagination {
      float: right;
    }
    .el-dialog__header {
      padding: 0px;
      height: 34px;
      line-height: 34px;
      background: #EDEEEE;
      .el-dialog__title {
        font-size: 14px;
        color: #2C2C2C;
      }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }
    .el-dialog__body {
      .el-table__header {
        .el-table-column--selection {
          >.cell {
              display: none;
          }
        }
      }
      .el-table-column--selection {
        >.cell {
          text-overflow: unset;
        }
      }
      .el-table.el-dialog__headerdata-source-table {
        th {
         .cell {
          span {
           font-size: 12px;
          }
         }
        }
         td {
         .cell {
           font-size: 13px;
           .el-checkbox {
             .el-checkbox__input {
               .el-checkbox__inner {
                 background-color: #fff;
                 border-color: #DCDFE6;
                 &::after {
                   border-color: var(--primary, #54ABF1);
                 }
               }
             }
             .is-checked {
               .el-checkbox__inner {
                 border-color: var(--primary, #54ABF1);
               }
             }
           }
           .file-list {
             > .one-file {
               cursor: pointer;
               font-size: 12px;
               color: #000;
               &:hover {
                 color: #55ACF1;
               }
             }
             .el-dropdown {
               .el-dropdown-link {
                 cursor: pointer;
                 font-size: 12px;
                 color: #000;
                 &:hover {
                   color: #55ACF1;
                 }
               }
             }
           }
         }
        }
        .el-table__header-wrapper {
          .el-table__header {
            .cell {
              .column-header {
                display: inline-block;
                width: 83.5px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
}
  /* 选择文件时下载预览用的tooltip*/
  .file-tooltip-datasource.el-tooltip__popper.is-light{
    width: 260px;
    padding: 10px 0;
    border: none;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    .file-cotent{
      height: 28px;
      width: 100%;
      line-height: 28px;
      padding: 0 10px;
      &:hover{
        background-color: #E2F1FE;
      }
    }
    .file-cotent+.file-cotent{
      margin-top: 10px;
    }
    span.item{
      display: inline-block;
      width: 110px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow:ellipsis;
      vertical-align: middle;
    }
    span.download,span.preivew{
      display: inline-block;
      width: 60px;
      cursor: pointer;
      color: #55ACF1;
      vertical-align: middle;
    }
  }
  .rc-data-source-dropdown.rc-file-dropdown{
    .el-dropdown-menu__item{
      width: auto;
      max-width: 320px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-data-source.vue